var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useMemo } from "react";
import styled from "styled-components";
import { tombac, Modal, ModalLayout, ModalHeader, ModalContent, ModalActions, Text, Button, Box, } from "tombac";
import { ProductsApiKeys } from "./ProductsApiKeys";
import { renderProductIcon } from "../../icons";
export var LegolandNavbarApiKeyModal = function (_a) {
    var isOpen = _a.isOpen, products = _a.products, setIsOpen = _a.setIsOpen;
    var productsByApiKey = useMemo(function () {
        return products === null || products === void 0 ? void 0 : products.reduce(function (acc, item) {
            if (item.access.status !== "GRANTED")
                return acc;
            var key = item.access.apiKey;
            if (!key)
                return acc;
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(item);
            return acc;
        }, {});
    }, [products]);
    var productsWithPendingAccess = products === null || products === void 0 ? void 0 : products.filter(function (product) { return product.access.status === "PENDING"; });
    var existProductWithExpiredAccess = products === null || products === void 0 ? void 0 : products.some(function (p) { return p.access.status === "EXPIRED"; });
    var existProductWithApiKey = products && productsByApiKey && Object.keys(productsByApiKey).length > 0;
    var existProductWithPendingAccess = products &&
        productsWithPendingAccess &&
        productsWithPendingAccess.length > 0;
    return (React.createElement(Modal, { isOpen: isOpen },
        React.createElement(ModalLayout, { "$width": "420u" },
            React.createElement(ModalHeader, null, " Your API key"),
            React.createElement(ModalContent, { variant: "scrollable" },
                products &&
                    !existProductWithApiKey &&
                    !existProductWithPendingAccess && (React.createElement(Text, { "$pb": "3sp" },
                    existProductWithExpiredAccess
                        ? "Your access to the products has expired. If you are interested in renewing your license, please contact"
                        : "You currently do not have access to any products. If you are interested in obtaining a license, please contact",
                    React.createElement(Text, { as: "a", href: "mailto:movesupport@tomtom.com", "$display": "inline-block", variant: "interactive" }, "movesupport@tomtom.com"))),
                existProductWithApiKey && (React.createElement(ProductsApiKeys, { products: productsByApiKey })),
                existProductWithPendingAccess && (React.createElement(Box, { "$mb": "2sp" },
                    React.createElement(Text, null, "Pending access:"),
                    productsWithPendingAccess.map(function (p) { return (React.createElement("span", { key: p.id },
                        " ",
                        renderProductIcon(p.id))); }))),
                React.createElement(Text, { fontWeight: "bold" }, "Read more about how to use API access on:"),
                React.createElement(LinkStyled, { as: "a", href: "https://developer.tomtom.com/documentation#traffic-apis" }, "https://developer.tomtom.com/documentation#traffic-apis")),
            React.createElement(ModalActions, null,
                React.createElement(Button, { onClick: function () { return setIsOpen(false); }, variant: "primary" }, "Close")))));
};
var LinkStyled = styled(Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  &:hover {\n    cursor: pointer;\n  }\n"], ["\n  color: ", ";\n  &:hover {\n    cursor: pointer;\n  }\n"])), tombac.color("accent", 600));
var templateObject_1;
//# sourceMappingURL=LegolandNavbarApiKeyModal.js.map